import React from 'react';
import { connect } from 'react-redux';
import { aceptoConfidencialidad } from './servicios.act';

import ConfidencialidadForm from '../contrato/confidencialidad.frm';

const mapState = (state) => {
    return {
		uid: state.recuperar.uid
	};
};

const mapDispatch = (dispatch,ownProps) => {
    return {
        loader: (show) => {
            dispatch({"type": "LOADER", "show": show});
        },
        aceptoConfidencialidad: (uid) => {
		    dispatch(aceptoConfidencialidad(uid));
		}
    }
}

class Confidencialidad extends React.Component{

    submit = (data) => {
        /*
       if(data.acepto == true) {
		    this.props.loader(true);
			this.props.aceptoConfidencialidad(this.props.uid);
		} else {
			this.props.pasoError();
		}*/
		this.props.loader(true);
		this.props.aceptoConfidencialidad(this.props.uid,data.acepto);
    }

	render() {
		return <ConfidencialidadForm onSubmit={this.submit} />;
	}    
}

export default connect(mapState, mapDispatch)(Confidencialidad);


// WEBPACK FOOTER //
// ./src/recuperar-contrasenia/confidencialidad.cmpt.js